<template>
    <div class="divider">
        <div class="divider-container">
            <strong>
                {{ handoverAcceptedBy }}
            </strong>
            heeft zich aangesloten bij de chat
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import Chat from '@/chat/Chat';

    const chat = Chat.getInstance();

    const handoverAcceptedBy = computed(() => chat.handoverAcceptedBy.value?.name.firstName ?? 'Medewerker');
</script>

<style scoped lang="scss">
    .divider {
        display: flex;
        align-items: center;
        text-align: center;
    }

    .divider::before,
    .divider::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #ccc;
    }

    .divider-container {
        padding: 10px 12px;
        background-color: #F5F5F5;
        border-radius: 26px;
        font-size: 11px;
        margin: 0 5px;
    }
</style>
